module.exports = "<a class=\"form-text\" href=\"#\" (click)=\"sortList()\">\n  {{label}}\n  <i [ngClass]=\"isSorted && isAsc ? 'fas fa-caret-up' : 'fas fa-caret-down'\" class=\"\" *ngIf=\"isSorted\" ></i>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pagination-sort/pagination-sort.component.html
// module id = XRtp
// module chunks = 0